import React from 'react'
import ReactToggle from 'react-toggle'
import './index.css'

export default function Toggle ({ defaultChecked, onChange, disabled }) {
  return (
    <ReactToggle
      defaultChecked={defaultChecked}
      icons={false}
      onChange={onChange}
      disabled={disabled}
    />
  )
}
